import React, { useState } from "react";

import SellInfo from "./SellInfo";

/**
 * A sell request, as one line in the orders directory.
 *
 * The card wrapper, the action column and the inline quotes panel are gone: quotes and commands
 * live in the page's right-hand panel now (`OrderQuotesDrawer`), the same arrangement the User CRM
 * uses. A row therefore never grows, and the list stays scannable however many quotes a deal has.
 */
const SellItemView = ({ item, newPriority, isFromUsersPage, selected = false, onOpen }) => {
  const [pxRequestId] = useState(item.px_request_id);

  return (
    <SellInfo
      {...{
        item,
        newPriority,
        pxRequestId,
        isFromUsersPage,
        selected,
        onOpen,
      }}
    />
  );
};

export default SellItemView;
